// @flow

import { type IncomingPayment } from './types';

export function getHash(incomingPayment: IncomingPayment): string {
  return incomingPayment['hash'];
}
